// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CostCodeHistoryQueryVariables = Types.Exact<{
  costCodeId?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type CostCodeHistoryQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> }> };


export const CostCodeHistoryDocument = gql`
    query CostCodeHistory($costCodeId: [ID!]) {
  costCodes(filter: {id: $costCodeId}) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useCostCodeHistoryQuery__
 *
 * To run a query within a React component, call `useCostCodeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCodeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCodeHistoryQuery({
 *   variables: {
 *      costCodeId: // value for 'costCodeId'
 *   },
 * });
 */
export function useCostCodeHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>(CostCodeHistoryDocument, options);
      }
export function useCostCodeHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>(CostCodeHistoryDocument, options);
        }
// @ts-ignore
export function useCostCodeHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>;
export function useCostCodeHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CostCodeHistoryQuery | undefined, CostCodeHistoryQueryVariables>;
export function useCostCodeHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>(CostCodeHistoryDocument, options);
        }
export type CostCodeHistoryQueryHookResult = ReturnType<typeof useCostCodeHistoryQuery>;
export type CostCodeHistoryLazyQueryHookResult = ReturnType<typeof useCostCodeHistoryLazyQuery>;
export type CostCodeHistorySuspenseQueryHookResult = ReturnType<typeof useCostCodeHistorySuspenseQuery>;
export type CostCodeHistoryQueryResult = ApolloReactCommon.QueryResult<CostCodeHistoryQuery, CostCodeHistoryQueryVariables>;